











































































































































import { Component, Prop, Model } from 'vue-property-decorator';
import { SwIcon } from '../sw-icon';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';

const cssPrefix = 'sw-checkbox';

/**
 * Controlled checkbox whose checked state fully depends on the input `checked`
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwCheckbox extends SwExtendedVue {
  @Prop({ type: String, required: true })
  name: string;

  @Prop({ default: false, type: [Boolean, String, Array] })
  @Model('change')
  checked: boolean | 'semi' | any[];

  @Prop({ default: 'on', type: [String, Number, Boolean] })
  value: string | number | boolean;

  @Prop({ type: Boolean, default: false })
  alwaysSubmit: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: true })
  clickableLabel: boolean;

  @Prop({ type: Boolean, default: false })
  asBlock: boolean;

  @Prop({ default: false, type: [Boolean, Number] })
  withMargin: boolean | number;

  @Prop({ default: false, type: Boolean })
  labelNoWrap: boolean;

  @Prop({ type: String, default: 'light' })
  theme: 'dark' | 'light';

  cssPrefix = cssPrefix;

  get effectiveChecked(): boolean {
    if (typeof this.checked === 'boolean') { return this.checked; }
    if (this.checked === 'semi') { return false; }
    if (Array.isArray(this.checked)) {
      return this.checked.includes(this.value);
    }
    return false;
  }

  get markIcon(): string {
    if (this.checked === 'semi') { return 'partially-selected'; }
    return 'checkmark';
  }

  get showMarkIcon(): boolean {
    return this.effectiveChecked || (this.checked === 'semi');
  }

  hasLabel(): boolean {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots);
    return slot.length > 0;
  }

  onClickBox() {
    if (this.disabled) { return; }
    let valueToEmit: boolean | any[] = false;
    if (Array.isArray(this.checked)) {
      valueToEmit = this.checked.slice();
      if (this.effectiveChecked) {
        const index = valueToEmit.indexOf(this.value);
        if (index >= 0) {
          valueToEmit.splice(index, 1);
        }
      } else {
        valueToEmit.push(this.value);
      }
    } else {
      valueToEmit = !this.effectiveChecked;
    }
    this.$emit('change', valueToEmit);
  }

  onClickLabel() {
    if (this.clickableLabel) {
      this.onClickBox();
    }
  }
}
